import React, { Component } from "react";
import "../assets/css/manora-report.css";

const SHOW_AFTER_PX = 300;

export default class ScrollToTopButton extends Component {
  state = { visible: false };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const visible = window.scrollY > SHOW_AFTER_PX;
    if (visible !== this.state.visible) this.setState({ visible });
  };

  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  render() {
    if (!this.state.visible) return null;
    return (
      <button
        type="button"
        className="manora-scroll-top-btn"
        onClick={this.scrollToTop}
        title="กลับไปด้านบนสุด"
      >
        ↑
      </button>
    );
  }
}
